import React, { useRef } from 'react';
import { useSpring } from '@react-spring/web';

import ClippedImage from './image/ClippedPreviewImage';
import useLocationInViewbox from '@src/hooks/wysiwyg_editor/useLocationInViewbox';
import type { TRect } from '../../../types/misc';
import type { Props } from './Image';

function locationHasNan(location: TRect | Record<string, never>) {
  return (
    Number.isNaN(location.x) ||
    Number.isNaN(location.y) ||
    Number.isNaN(location.height) ||
    Number.isNaN(location.width)
  );
}

function PreviewImage({
  data,
  frameViewboxSpringValues
}: Props): React.ReactElement {
  const imageLocationInViewbox = useLocationInViewbox(data.contentLocation);
  const imageRef = useRef<SVGImageElement>(null);

  const [imageSpringValues, _imageSpringApi] = useSpring<TRect>(
    () => ({
      config: { duration: 1 },
      ...imageLocationInViewbox
    }),
    [imageLocationInViewbox]
  );

  if (
    data.href &&
    imageLocationInViewbox &&
    !locationHasNan(imageLocationInViewbox) &&
    data.contentLocation.height
  )
    return (
      <ClippedImage
        clipId={data.id}
        imageUrl={data.href}
        frameSpringValues={frameViewboxSpringValues}
        imageRef={imageRef}
        imageSpringValues={imageSpringValues}
        key="image"
      />
    );

  return null;
}

export default PreviewImage;
